import { render, staticRenderFns } from "./UpdateICD9.vue?vue&type=template&id=6d8f30e1"
import script from "./UpdateICD9.vue?vue&type=script&lang=js"
export * from "./UpdateICD9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d8f30e1')) {
      api.createRecord('6d8f30e1', component.options)
    } else {
      api.reload('6d8f30e1', component.options)
    }
    module.hot.accept("./UpdateICD9.vue?vue&type=template&id=6d8f30e1", function () {
      api.rerender('6d8f30e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/home/icd9/UpdateICD9.vue"
export default component.exports